import lightbox from "lightbox2/dist/js/lightbox-plus-jquery.min.js";

lightbox.option({
  resizeDuration: 100,
  wrapAround: true
});
